import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=06176ced&scoped=true"
import script from "./imgPreview.vue?vue&type=script&lang=js"
export * from "./imgPreview.vue?vue&type=script&lang=js"
import style0 from "./imgPreview.vue?vue&type=style&index=0&id=06176ced&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06176ced",
  null
  
)

export default component.exports